<div class="flex flex-col items-center justify-center gap-3 w-screen h-screen">
	<img
		ngSrc="../../../../assets/img/onetag_logo_description.png"
		alt="OneTag Logo"
		class="w-[28rem] h-auto"
		height="72"
		width="265"
	/>
	<h1 class="font-bold text-error text-5xl">403 - Forbidden</h1>
	<div class="font-bold text-secondary">You don't have permission to access this resource.</div>
	<p-button
		label="Return to home page"
		icon="fas fa-arrow-left"
		[link]="true"
		routerLink="/"
	/>
</div>
